import Http from '../api/http/';

export default class UserWallet extends Http {
  constructor() {
    super();
  }
  /** 提现列表
   * @param {integer} payStatus - 0-待支付，1支付中，3-已支付(线上)，4-支付失败（已驳回）5线下支付
   * @param {array} payTypeList -
   * @param {array} statusList -
   */
  userWallet_userWithdrawList() {
    return super.post('userWallet/userWithdrawList', ...arguments);
  }
  /**
   * 线下支付
   * @param {string} reason - 原因
   * @param {array} withdrawPayNoList - 用户支付单号
   */
  userWallet_offlinePay() {
    return super.post('userWallet/offlinePay', ...arguments);
  }
  /**
   * 获取支付信息
   * @param {string} reason - 原因
   * @param {array} withdrawPayNoList - 用户支付单号
   */
  userWaller_getPayInfo() {
    return super.post('userWallet/getPayInfo', ...arguments);
  }
  /**
   * 提现导出
   * @param {integer} payStatus - 0-待支付，1支付中，3-已支付(线上)，4-支付失败（已驳回）5线下支付
   * @param {array} payTypeList -
   * @param {array} statusList -
   */
  userWallet_exportWithdraw() {
    return super.post('userWallet/exportWithdraw', ...arguments);
  }
  /**
   * 终止支付
   * @param {string} operatorId - 操作人ID
   * @param {string} reason - 原因
   */
  userWallet_terminatePay() {
    return super.post('userWallet/terminatePay', ...arguments);
  }
}
